import { gql } from '@apollo/client';

export const LOCK_CATEGORY = gql`
  mutation LockCategory($where: CategoryUniqueFilterInput!) {
    lockCategory(where: $where)
  }
`;

export const RETAIN_LOCK_CATEGORY = gql`
  mutation RetainLockCategory($where: CategoryUniqueFilterInput!) {
    retainCategoryLock(where: $where)
  }
`;

export const UNLOCK_CATEGORY = gql`
  mutation UnlockCategory($where: CategoryUniqueFilterInput!) {
    unlockCategory(where: $where)
  }
`;
